module.exports = __webpack_public_path__ + "3f161b38a57f2bbaa9f56828ac240b9d.svg";